import IBiuroBaseInfo from '~/components/biura/types/IBiuroBaseInfo';
import IGoogleMapPosition from '~/components/map/types/IGoogleMapPosition';

const getMarkerPosition = <T extends IBiuroBaseInfo>(marker: T): IGoogleMapPosition => ({
  lat: marker.SzerokoscGeo || 0,
  lng: marker.DlugoscGeo || 0,
});
export default getMarkerPosition;
